import { useTheme } from '../../../../components/common/Theme';

/** Shared simple light/dark tokens for Access Settings popups */
export function useAccessTheme() {
  const { theme } = useTheme();
  const isLight = theme === 'white';

  return {
    isLight,
    overlay: isLight ? 'bg-black/40' : 'bg-black/70',
    panel: isLight
      ? 'bg-white border-neutral-200 text-neutral-900'
      : 'bg-neutral-900 border-neutral-800 text-white',
    border: isLight ? 'border-neutral-200' : 'border-neutral-800',
    header: isLight ? 'bg-neutral-50 border-neutral-200' : 'bg-neutral-900 border-neutral-800',
    footer: isLight ? 'bg-neutral-50 border-neutral-200' : 'bg-neutral-950/50 border-neutral-800',
    muted: isLight ? 'text-neutral-500' : 'text-gray-400',
    title: isLight ? 'text-neutral-900' : 'text-white',
    body: isLight ? 'text-neutral-700' : 'text-gray-300',
    input: isLight
      ? 'bg-white border-neutral-300 text-neutral-900 placeholder:text-neutral-400 focus:border-indigo-400 focus:ring-1 focus:ring-indigo-200'
      : 'bg-neutral-800 border-neutral-700 text-white placeholder:text-gray-500 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/30',
    tableShell: isLight ? 'border-neutral-200 bg-white' : 'border-neutral-800 bg-black/10',
    tableHead: isLight ? 'bg-neutral-50 text-neutral-500' : 'bg-neutral-950 text-gray-400',
    card: isLight
      ? 'border-neutral-200/80 bg-white shadow-sm'
      : 'border-neutral-800 bg-neutral-900/40 shadow-sm shadow-black/20',
    directoryHead: isLight
      ? 'bg-neutral-50/95 text-neutral-500'
      : 'bg-neutral-950/90 text-gray-400',
    rowHover: isLight ? 'hover:bg-neutral-50' : 'hover:bg-neutral-800/60',
    rowBorder: isLight ? 'border-neutral-100' : 'border-neutral-800',
    iconRing: isLight ? 'ring-1 ring-indigo-100 shadow-sm' : 'ring-1 ring-indigo-900/40 shadow-sm shadow-black/20',
    btnQuiet: isLight
      ? 'border border-neutral-200 text-neutral-600 hover:bg-neutral-50 hover:text-neutral-900'
      : 'border border-neutral-700 text-gray-300 hover:bg-neutral-800',
    tabHover: isLight ? 'hover:bg-indigo-50/60' : 'hover:bg-indigo-500/10',
    badge: isLight
      ? 'bg-neutral-100 text-neutral-700 border-neutral-200'
      : 'bg-neutral-800 text-gray-300 border-neutral-700',
    badgeAccent: isLight
      ? 'bg-indigo-50 text-indigo-700 border-indigo-200'
      : 'bg-indigo-900/40 text-indigo-300 border-indigo-700/50',
    iconBg: isLight ? 'bg-indigo-50 text-indigo-600' : 'bg-indigo-900/30 text-indigo-400',
    closeBtn: isLight
      ? 'text-neutral-400 hover:text-neutral-700 hover:bg-neutral-100'
      : 'text-gray-400 hover:text-white hover:bg-neutral-800',
    btnPrimary: 'bg-indigo-600 hover:bg-indigo-700 text-white',
    btnSecondary: isLight
      ? 'border border-neutral-300 text-neutral-700 hover:bg-neutral-100'
      : 'border border-neutral-700 text-gray-300 hover:bg-neutral-800',
    btnGhost: isLight
      ? 'text-neutral-500 hover:text-neutral-800 hover:bg-neutral-100'
      : 'text-gray-400 hover:text-white hover:bg-neutral-800',
    accentText: isLight ? 'text-indigo-600' : 'text-indigo-400',
    errorBox: isLight
      ? 'bg-red-50 border-red-200 text-red-600'
      : 'bg-red-900/20 border-red-800/50 text-red-400',
    toggleOn: 'text-green-500',
    toggleOff: isLight ? 'text-neutral-400' : 'text-gray-500',
    actionHover: isLight ? 'hover:bg-neutral-100' : 'hover:bg-neutral-800',
  };
}
